import Btn from "../Btn";
import PersonStart from "./PersonStar";
import Chart from "./Chart";
import Innovation from "./Innovation";
import "./index.sass";

interface AnimationLeftBtn {
  id: number;
  label: string;
  icon: "person-star" | "chart" | "innovation";
  style?: React.CSSProperties;
  hoverStyle?: React.CSSProperties;
}

interface AnimationLeftProps {
  dataBtns: AnimationLeftBtn[];
  color: "purple" | "blue" | "orange" | "darkOrange" | "red";
  active: number;
  setActive: (active: number) => void;
}

const PanelLeft = ({
  dataBtns,
  color,
  active,
  setActive,
}: AnimationLeftProps) => {
  const icons = {
    "person-star": <PersonStart />,
    chart: <Chart />,
    innovation: <Innovation />,
  };

  return (
    <div id="panel-left-container">
      {dataBtns.map((btnData, index) => (
        <Btn
          key={btnData.id}
          label={btnData.label ?? ""}
          onClick={() => setActive(btnData.id)}
          icon={icons[btnData.icon]}
          active={btnData.id === active}
          color={color}
          style={{
            ...(index === 0 ? {} : { marginTop: "var(--height-48)" }),
            ...btnData.style,
          }}
        />
      ))}
    </div>
  );
};

export default PanelLeft;
